class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedMap = new Map();
    this.focusElement = this.input;
    this.resetButton.addEventListener('click', this.clear.bind(this));
    this.input.addEventListener('input', FoxTheme.utils.debounce(this.onChange.bind(this), 300));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.input.addEventListener('blur', this.kgOnBlur.bind(this));
    this.searchContent = this.querySelector('.search__content');
    this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';
    this.header = document.querySelector('header');
    this.toggleNavigationButton = document.querySelector('.toggle-navigation-button');
    this.togglePanelButton = document.getElementById('OpenSearchPanelButton');
    this.formResetButton = document.getElementById('FormResetButton');
    this.isOpen = false;

    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener('click', this.boundHandleClickOutside);
    this.searchProductTypes?.addEventListener('change', this.handleProductTypeChange.bind(this));

    this.isHeaderSearch = this.closest('header') !== null;

    document.addEventListener('menu-drawer:open', () => {
      this.classList.remove('predictive-search-open');
      document.body.classList.remove('search-open');
    });

    this.states = {
      OPEN: 'predictive-search-open',
      LOADING: 'btn--loading',
      SEARCH_OPEN: 'search-open',
    };

    if (this.formResetButton) {
      this.formResetButton.addEventListener('click', () => {
        this.toggleSearchState(false);
        this.searchContent.classList.add('hidden');
        this.open = false;
      });
    }

    
    if (this.togglePanelButton) {
      this.togglePanelButton.addEventListener('click', () => {       
        if (!this.open) {
          this.toggleSearchState();
          this.searchContent?.classList.remove('hidden');
          this.open = true;
        } else {
            this.toggleSearchState(false);
            this.searchContent.classList.add('hidden');
            this.open = false;
        }
      });
    }
  }

  get input() {
    return this.querySelector('input[type="search"]');
  }
  get resetButton() {
    return this.querySelector('button[type="reset"]');
  }

  get searchProductTypes() {
    return this.querySelector('#SearchProductTypes');
  }

  kgOnBlur(event) {
    this.classList.remove('kg-predictive-search-open');
  }
  
  onFocus(event) {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom)}px`
    );
    if (this.isHeaderSearch && !this.searchRecommendationEmpty) {
      document.body.classList.add('search-open');
      this.toggleNavButtonVisibility(false);
    }

    if (!this.searchRecommendationEmpty) {
      this.searchContent.classList.remove('hidden');
    }
    this.classList.add('predictive-search-open');
    // if (this.getQuery().length === 0) {
    //   if (this.searchRecommendationEmpty) {
    //     this.searchContent.classList.add('hidden');
    //   }
    //   return;
    // }
    const url = this.setupURL().toString();
    this.renderSection(url, event);
    this.classList.add('kg-predictive-search-open');
  }

  getQuery() {
    return this.input.value.trim();
  }

  clear(event = null) {
    event?.preventDefault();
    this.input.value = '';
    this.input.focus();
    this.removeAttribute('results');
    this.toggleSearchState(false);
  }

  handleProductTypeChange(evt) {
    const query = this.getQuery();
    if (query.length > 0) {
      const url = this.setupURL().toString();
      this.renderSection(url);
    }
  }

  setupURL() {
    const url = new URL(`${window.shopUrl}${FoxTheme.routes.predictive_search_url}`);
    const targetSectionId = FoxTheme.utils.getSectionId(this);
    const ajaxSectionId = this.dataset.ajaxSectionId || targetSectionId;
    let search_term = this.getQuery();
    if (this.searchProductTypes && this.searchProductTypes.value != '') {
      search_term = `product_type:${this.searchProductTypes.value} AND ${encodeURIComponent(search_term)}`;
    }
    return (
      url.searchParams.set('q', search_term),
      url.searchParams.set('resources[limit]', this.dataset.resultsLimit || 3),
      url.searchParams.set('resources[limit_scope]', 'each'),
      url.searchParams.set('section_id', ajaxSectionId),
      url
    );
  }

  onChange() {
    // if (this.getQuery().length === 0) {
    //   this.clear();
    //   return;
    // }
    const url = this.setupURL().toString();
    this.renderSection(url);
  }

  renderSection(url) {
    this.cachedMap.has(url) ? this.renderSectionFromCache(url) : this.renderSectionFromFetch(url);
  }

  renderSectionFromCache(url) {
    const responseText = this.cachedMap.get(url);
    this.renderSearchResults(responseText), this.setAttribute('results', '');
  }

  renderSectionFromFetch(url) {
    this.setLoadingState(true);

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then((responseText) => {
        this.renderSearchResults(responseText);
        this.cachedMap.set(url, responseText);
      })
      .catch((error) => {
        console.error('Error fetching data: ', error);
        this.setAttribute('error', 'Failed to load data');
      })
      .finally(() => this.setLoadingState(false));
  }
  // renderSearchResults(responseText) {
  //   const sectionId = FoxTheme.utils.getSectionId(this);
  //   const targetId = 'PredictiveSearchResults-' + sectionId;
  //   const responseId = this.dataset.ajaxSectionId ? 'PredictiveSearchResults-' + this.dataset.ajaxSectionId : targetId;
  //   const targetElement = document.getElementById(targetId);

  //   if (targetElement) {
  //     const parser = new DOMParser();
  //     const parsedDoc = parser.parseFromString(responseText, 'text/html');
  //     const contentElement = parsedDoc.getElementById(responseId);

  //     if (contentElement) {
  //       this.searchContent?.classList.remove('hidden');
  //       targetElement.innerHTML = contentElement.innerHTML;
  //       const targetFormId = `PredictiveSearch-${sectionId}`;
  //       targetElement.querySelectorAll('[data-ajax-form-submit]').forEach((button) => {
  //         button.setAttribute('form', targetFormId);
  //       });

  //       if (this.isHeaderSearch && !document.body.classList.contains('search-open')) {
  //         document.body.classList.add('search-open');
  //         this.toggleNavButtonVisibility(true);
  //         this.classList.add('predictive-search-open');
  //       } else {
  //         this.classList.add('predictive-search-open');
  //       }
  //     } else {
  //       console.error(`Element with id '${id}' not found in the parsed response.`);
  //     }
  //   } else {
  //     console.error(`Element with id '${id}' not found in the document.`);
  //   }
  // }
 renderSearchResults(responseText) {
    // Find the form with kg-main-search-class within the current search instance
    const searchForm = this.querySelector('.kg-main-search-class');
    
    if (!searchForm) {
      console.error(`Form with class 'kg-main-search-class' not found in the current search instance.`);
      return;
    }

    // Find the results container within the current search instance
    // It should be a sibling or within the same parent structure
    const targetElement = this.querySelector('.search__results')?.querySelector('[role="listbox"]') || 
                          this.querySelector('[role="listbox"]');

    if (targetElement) {
      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(responseText, 'text/html');
      
      // Find the results container in the parsed response using the same approach
      const contentElement = parsedDoc.querySelector('[role="listbox"]');

      if (contentElement) {
        this.searchContent?.classList.remove('hidden');
        targetElement.innerHTML = contentElement.innerHTML;
        
        // Get the form ID from the current search form
        const targetFormId = searchForm.id || searchForm.getAttribute('id');
        if (targetFormId) {
          targetElement.querySelectorAll('[data-ajax-form-submit]').forEach((button) => {
            button.setAttribute('form', targetFormId);
          });
        }

        if (this.isHeaderSearch && !document.body.classList.contains('search-open')) {
          document.body.classList.add('search-open');
          this.toggleNavButtonVisibility(true);
          this.classList.add('predictive-search-open');
        } else {
          this.classList.add('predictive-search-open');
        }
      } else {
        console.error(`Results container with role 'listbox' not found in the parsed response.`);
      }
    } else {
      console.error(`Results container with role 'listbox' not found in the current search instance.`);
    }
  }
  handleClickOutside(event) {
    const target = event.target;
    const shouldClose = this.isHeaderSearch
      ? !this.contains(target) &&
        ((target.classList.contains('fixed-overlay') && target.closest('.header-section')) ||
          target.classList.contains('header__search-close'))
      : !this.contains(target);

    if (shouldClose) {
      setTimeout(() => this.toggleSearchState(false));
    }
  }

  toggleSearchState(isOpen) {
    this.classList.toggle(this.states.OPEN, isOpen);
    if (this.isHeaderSearch) {
      document.body.classList.toggle(this.states.SEARCH_OPEN, isOpen);
      this.toggleNavButtonVisibility(!isOpen);
    }
    if (!isOpen && this.searchRecommendationEmpty) {
      this.searchContent?.classList.add('hidden');
    }
  }

  toggleNavButtonVisibility(isOpen) {
    this.toggleNavigationButton && this.toggleNavigationButton.classList.toggle('is-show', isOpen);
  }

  setLoadingState(isLoading) {
    if (isLoading) {
      this.setAttribute('loading', 'true');
      this.resetButton.classList.add(this.states.LOADING);
    } else {
      this.removeAttribute('loading');
      this.resetButton.classList.remove(this.states.LOADING);
      this.setAttribute('results', 'true');
    }
  }
}
customElements.define('predictive-search', PredictiveSearch);
